// extracted by mini-css-extract-plugin
export default {"addressSection":"tU-z","disabled":"uU-z","sectionButtons":"vU-z","logo":"wU-z"};